import React from 'react';
import { Heart, Send, Gift, MessageCircle } from 'lucide-react';
export const LiveCam = () => {
  return <section className="space-y-4 max-md:px-2" data-id="element-9329">
      <div className="flex items-center justify-between" data-id="element-9330">
        <h2 className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-9331">
          Live Cam
        </h2>
        <div className="text-xs px-2 py-0.5 bg-red-500/30 rounded-full flex items-center gap-1" data-id="element-9332">
          <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-9333"></span>
          <span className="text-red-600 dark:text-red-400" data-id="element-9334">LIVE</span>
        </div>
      </div>
      <div className="relative w-full rounded-xl overflow-hidden border-0 sm:border sm:border-gray-200 dark:sm:border-gray-700/30 max-md:border max-md:border-gray-200 dark:max-md:border-gray-700/30" data-id="element-9335">
        <div className="aspect-video bg-gray-100 dark:bg-gray-900 relative" data-id="element-9336">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hVeSxxpDikr1zQUyWxYzJJ/image.png" alt="Live stream" className="w-full h-full object-cover" data-id="element-9337" />
          {/* Top overlay */}
          <div className="absolute top-0 left-0 right-0 p-3 flex justify-between items-start" data-id="element-9338">
            <div className="flex items-center gap-2" data-id="element-9339">
              <h3 className="font-bold text-white" data-id="element-9340">Sophia</h3>
              <div className="text-xs px-2 py-0.5 bg-black/50 backdrop-blur-sm rounded-full flex items-center gap-1" data-id="element-9341">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-9342"></span>
                <span data-id="element-9343">Live</span>
                <span data-id="element-9344">•</span>
                <span data-id="element-9345">1.2k watching</span>
              </div>
            </div>
            <button className="w-8 h-8 flex items-center justify-center rounded-full bg-black/50 backdrop-blur-sm" data-id="element-9346">
              ✕
            </button>
          </div>
          {/* Goal bar */}
          <div className="absolute top-12 right-3 bg-black/50 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-2" data-id="element-9347">
            <span className="text-xs" data-id="element-9348">Goal: Cum Show</span>
            <div className="w-24 h-2 bg-gray-700 rounded-full overflow-hidden" data-id="element-9349">
              <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 w-4/5 rounded-full" data-id="element-9350"></div>
            </div>
            <span className="text-xs" data-id="element-9351">842/1000</span>
            <Heart size={14} className="text-pink-500" data-id="element-9352" />
          </div>
          {/* King/Top Tipper */}
          <div className="absolute top-24 left-3 bg-black/50 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-2" data-id="element-9353">
            <span className="text-xs" data-id="element-9354">👑 King: User123</span>
            <span className="text-xs text-yellow-400" data-id="element-9355">500 💗</span>
          </div>
          {/* Toy Connected */}
          <div className="absolute bottom-3 right-3 bg-black/50 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-2" data-id="element-9356">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-9357"></span>
            <span className="text-xs" data-id="element-9358">Toy Connected</span>
          </div>
          {/* Chat messages */}
          <div className="absolute bottom-12 left-3 space-y-2 max-w-xs" data-id="element-9359">
            <div className="bg-black/50 backdrop-blur-sm rounded-lg px-3 py-1" data-id="element-9360">
              <div className="flex items-center gap-1" data-id="element-9361">
                <span className="text-xs font-bold text-purple-400" data-id="element-9362">
                  User456
                </span>
                <span className="text-xs" data-id="element-9363">💜</span>
              </div>
              <p className="text-xs" data-id="element-9364">You look amazing today! 😍</p>
            </div>
            <div className="bg-black/50 backdrop-blur-sm rounded-lg px-3 py-1" data-id="element-9365">
              <div className="flex items-center gap-1" data-id="element-9366">
                <span className="text-xs font-bold text-yellow-400" data-id="element-9367">
                  LoverBoy
                </span>
                <span className="text-xs" data-id="element-9368">👑</span>
              </div>
              <p className="text-xs" data-id="element-9369">Can you blow a kiss? 💋</p>
            </div>
          </div>
          {/* Floating hearts */}
          <div className="absolute inset-0 pointer-events-none" data-id="element-9370">
            <div className="absolute bottom-1/4 left-1/4 text-xl animate-float-slow" data-id="element-9371">
              ❤️
            </div>
            <div className="absolute top-1/3 right-1/3 text-xl animate-float-medium" data-id="element-9372">
              ❤️
            </div>
            <div className="absolute bottom-1/2 right-1/4 text-xl animate-float-fast" data-id="element-9373">
              ❤️
            </div>
          </div>
        </div>
        {/* Controls */}
        <div className="p-3 bg-white dark:bg-gray-900 border-t-0 sm:border-t sm:border-gray-200 dark:sm:border-gray-800/30 flex justify-between items-center max-md:border-t max-md:border-gray-200 dark:max-md:border-gray-800/30" data-id="element-9374">
          <div className="flex items-center gap-3" data-id="element-9375">
            <button className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800" data-id="element-9376">
              <Heart size={18} className="text-pink-500 dark:text-pink-400" data-id="element-9377" />
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800" data-id="element-9378">
              <Gift size={18} className="text-purple-500 dark:text-purple-400" data-id="element-9379" />
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800" data-id="element-9380">
              <MessageCircle size={18} className="text-gray-500 dark:text-gray-400" data-id="element-9381" />
            </button>
          </div>
          <div className="flex items-center gap-2" data-id="element-9382">
            <button className="text-sm px-3 py-1 bg-gray-100 dark:bg-gray-800 rounded-full text-gray-700 dark:text-gray-300" data-id="element-9383">
              $5 Tip
            </button>
            <button className="text-sm px-3 py-1 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white flex items-center gap-1" data-id="element-9384">
              <span data-id="element-9385">Send Tip</span>
              <Heart size={14} data-id="element-9386" />
            </button>
          </div>
        </div>
        {/* Input */}
        <div className="p-3 bg-white dark:bg-gray-900 border-t-0 sm:border-t sm:border-gray-200 dark:sm:border-gray-800/30 max-md:border-t max-md:border-gray-200 dark:max-md:border-gray-800/30" data-id="element-9387">
          <div className="flex items-center gap-2" data-id="element-9388">
            <div className="flex-1 bg-gray-100 dark:bg-gray-800 rounded-full px-4 py-2 flex items-center" data-id="element-9389">
              <input type="text" placeholder="Type a message..." className="bg-transparent border-none outline-none w-full text-sm text-gray-700 dark:text-gray-300" data-id="element-9390" />
            </div>
            <button className="w-10 h-10 flex items-center justify-center rounded-full bg-pink-600" data-id="element-9391">
              <Send size={18} className="text-white" data-id="element-9392" />
            </button>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between" data-id="element-9393">
        <div className="text-sm" data-id="element-9394">
          <span className="text-gray-500 dark:text-gray-400" data-id="element-9395">
            Next show in:
          </span>
          <span className="ml-1 font-medium text-gray-700 dark:text-gray-300" data-id="element-9396">
            2h 15m
          </span>
        </div>
        <button className="text-sm px-3 py-1 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white" data-id="element-9397">
          Schedule Reminder
        </button>
      </div>
    </section>;
};